const scrollUp = "scroll-up"
const scrollDown = "scroll-down"
const announcementBar = document.querySelector(".sc-announcement-bar__wrapper")
const headerGroup = document.querySelector(".sc-header-group")
let lastScroll = 0
const searchIcon = document.querySelector("[data-icon-search] a")
const searchDrawerCloseButton = document.querySelector(".sc-header-search__close-button")
const searchDrawer = document.querySelector(".sc-header-search")
const mobileMenuButton = document.querySelector("[data-icon-burger]")
const mobileMenuCloseButton = document.querySelector(".menu-drawer__close-button")
const menuDrawer = document.getElementById("menu-drawer")
const menuDetailsContainer = document.querySelector(".js-menu-drawer-container")

if (announcementBar){
    var announcementBarHeight = announcementBar.offsetHeight || 0
}

headerGroup.style.transform = `translateY(${announcementBarHeight}px)`

window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset

    if (currentScroll > 0 && currentScroll > lastScroll && !document.body.classList.contains(scrollDown)) {
        document.body.classList.remove(scrollUp)
        document.body.classList.add(scrollDown)
        headerGroup.style.transform = `translateY(0)`
    }

    if (currentScroll < lastScroll && document.body.classList.contains(scrollDown)) {
        document.body.classList.remove(scrollDown)
        document.body.classList.add(scrollUp)

        /* if (announcementBar){
             announcementBar.style.transform = `translateY(0)`
         }*/

        headerGroup.style.transform = `translateY(${announcementBarHeight}px)`
    }

    lastScroll = currentScroll
})

if (searchIcon){
    searchIcon.addEventListener("click", (event)=> openSearchDrawer(event))
}

if (searchDrawerCloseButton){
    searchDrawerCloseButton.addEventListener("click", (event) => closeSearchDrawer(event))
}

if (mobileMenuButton){
    mobileMenuButton.addEventListener("click", (event) => openMenuDrawer(event))
}

if (mobileMenuCloseButton){
    mobileMenuCloseButton.addEventListener("click", (event) => closeMenuDrawer(event))
}

const openSearchDrawer = (event) => {
    event.preventDefault()
    if (searchDrawer){
        searchDrawer.classList.add("search-drawer__open")
        document.body.classList.add("drawer-open")
    }
}

const closeSearchDrawer = (event) => {
    event.preventDefault()
    if (searchDrawer){
        searchDrawer.classList.remove("search-drawer__open")
        document.body.classList.remove("drawer-open")
    }
}

const openMenuDrawer = (event) => {
    event.preventDefault()
    if (menuDrawer){
        mobileMenuButton.classList.add("drawer-open")
    }
    if (menuDetailsContainer){
        menuDetailsContainer.open = true;
        setTimeout(() => {
            menuDetailsContainer.classList.add("menu-opening");
        });
    }
    document.body.classList.add(`overflow-hidden`);
}

const closeMenuDrawer = (event) => {
    event.preventDefault()
    if (menuDrawer){
        mobileMenuButton.classList.remove("drawer-open")
    }
    if (menuDetailsContainer){
        menuDetailsContainer.classList.remove("menu-opening");
        closeAnimation(menuDetailsContainer);
    }
    document.body.classList.remove(
        `overflow-hidden`
    );

}

function closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
        if (animationStart === undefined) {
            animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
            window.requestAnimationFrame(handleAnimation);
        } else {
            detailsElement.removeAttribute("open");
            if (detailsElement.closest("details[open]")) {
                trapFocus(
                    detailsElement.closest("details[open]"),
                    detailsElement.querySelector("summary")
                );
            }
        }
    };

    window.requestAnimationFrame(handleAnimation);
}
